module.exports = __webpack_public_path__ + "img/No_image_available.svg.b080659e.png";